const WithdrawingButton = ({ onTap, value }) => {
  return <div className="withdrawing-button" onClick={onTap} >
    <h3>{value}</h3>
    <img src="/assets/icons/ic_star_small.svg" alt="ic_star_small" />
  </div>;
};

export default WithdrawingButton;